import Vue from 'vue'
import Router from 'vue-router'

import Index from '@/components/pages/Index'
import Login from '@/components/pages/Login'
import Dashboard from '@/components/pages/Dashboard'
import Register from '@/components/pages/Register'
import User from '@/components/pages/User'
import UserEdit from '@/components/pages/UserEdit'
import Project from '@/components/pages/Project'
import ProjectCrowdfund from '@/components/pages/ProjectCrowdfund'
import Donate from '@/components/pages/Donate'
import CheckoutSuccess from '@/components/pages/CheckoutSuccess'
import CreateProject from '@/components/pages/CreateProject'
import University from '@/components/pages/University'
import Help from '@/components/pages/Help'

Vue.use(Router)

export default new Router({

  // Uses History API in browsers, allowing us to remove the hash (#) from the URL
  // See: https://router.vuejs.org/guide/essentials/history-mode.html#html5-history-mode
  // For deployment, requires some config: https://cli.vuejs.org/guide/deployment.html#render
  // Navigation guards, see: https://router.vuejs.org/guide/advanced/navigation-guards.html#navigation-guards
  mode: 'history',

  routes: [
    { path: '/',                            name: 'Index',           component: Index },
    { path: '/login',                       name: 'Login',           component: Login },
    { path: '/dashboard',                   name: 'Dashboard',       component: Dashboard },
    { path: '/register',                    name: 'Register',        component: Register },
    { path: '/user/:username',              name: 'User',            component: User },
    { path: '/user/:username/edit',         name: 'UserEdit',        component: UserEdit },
    { path: '/project/:projectId',          name: 'Project',         component: Project, alias: '/project/:projectId/*'},
    { path: '/project/:projectId/crowdfund',name: 'ProjectCrowdfund',component: ProjectCrowdfund },
    { path: '/donate/:projectId',           name: 'Donate',          component: Donate },
    { path: '/checkout/success/:projectId', name: 'CheckoutSuccess', component: CheckoutSuccess },
    { path: '/createProject',               name: 'CreateProject',   component: CreateProject },
    { path: '/u/:universitySlug',           name: 'University',      component: University },
    { path: '/help',                        name: 'Help',            component: Help },
  ]

})



// WEBPACK FOOTER //
// ./src/router/index.js